
import ElementEqual from "../../../assets/outline/ElementEqual.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ElementEqualIcon({ className, dataTestid = "ElementEqualIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ElementEqual data-testid={dataTestid} className={classes} {...rest} />
  );
}
